import { render, staticRenderFns } from "./ConsultarManifestacoes.vue?vue&type=template&id=1e6f78b6"
import script from "./ConsultarManifestacoes.vue?vue&type=script&lang=ts"
export * from "./ConsultarManifestacoes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports